let tabsSlider;
export default () => ({
	id: '',

	createSlider() {
		const settings = {
			observer: true,
			observeParents: true,
			slidesPerMove: 1,
			slidesPerView: 1.15,
			spaceBetween: 24,
			slidesOffsetAfter: 24,
			breakpoints: {
				681: {
					slidesPerView: 1.5,
				},
			},
		};

		tabsSlider = new window.Swiper(`.${this.id} .slider`, settings);
	},

	initVideoPlaying() {
		const videos = document.querySelectorAll(`.${this.id} video`);
		if (videos.length === 0) return;
		videos.forEach((video) => {
			this.observVideo(video);
		});
	},
	observVideo(video) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						video.play();
					} else {
						video.pause();
					}
				});
			},
			{ threshold: 0.9 },
		);
		observer.observe(video);
	},

	scrollToSlide() {
		const options = document.querySelectorAll(`.${this.id} [data-option-index]`);
		if (options.length === 0) return;
		options.forEach((option) => {
			option.addEventListener('click', () => {
				options.forEach((option) => option.classList.remove('active'));
				option.classList.add('active');
				tabsSlider.slideTo(Number(option.dataset.optionIndex));
			});
		});
	},

	init() {
		this.$watch('id', () => {
			this.createSlider();
			this.initVideoPlaying();
			this.scrollToSlide();
		});
	},
});
